/* ==========================================================================
   Podsmania — product.js
   Variant selection, media switching, sticky buy bar, share button.
   ========================================================================== */

(function () {
  "use strict";

  var config = window.Podsmania || {};
  var strings = config.strings || {};

  function money(cents) {
    return window.PodsmaniaMoney ? window.PodsmaniaMoney(cents) : cents / 100;
  }

  /* ------------------------------------------------------------------------
     Variant picker
     ------------------------------------------------------------------------ */

  function initVariantPicker(scope) {
    var pickers = (scope || document).querySelectorAll("[data-variant-picker]:not([data-ready])");

    Array.prototype.forEach.call(pickers, function (picker) {
      picker.setAttribute("data-ready", "true");

      var sectionId = picker.getAttribute("data-section");
      var dataEl = document.querySelector('[data-variant-data="' + sectionId + '"]');
      if (!dataEl) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (error) {
        return;
      }

      var section = picker.closest(".product-section") || document;

      function selectedOptions() {
        var values = [];

        Array.prototype.forEach.call(
          picker.querySelectorAll("[data-option-radio]:checked, [data-option-select]"),
          function (input) {
            values[parseInt(input.getAttribute("data-option-index"), 10)] = input.value;
          }
        );

        return values;
      }

      function findVariant(values) {
        for (var i = 0; i < variants.length; i++) {
          var variant = variants[i];
          var match = true;

          for (var j = 0; j < values.length; j++) {
            if (values[j] !== undefined && variant.options[j] !== values[j]) {
              match = false;
              break;
            }
          }

          if (match) return variant;
        }
        return null;
      }

      function update() {
        var values = selectedOptions();
        var variant = findVariant(values);

        // Keep each option's label in sync with what's chosen.
        values.forEach(function (value, index) {
          var display = picker.querySelector('[data-option-display="' + index + '"]');
          if (display && value !== undefined) display.textContent = value;
        });

        var idInput = section.querySelector("[data-variant-id]");
        var button = section.querySelector(".product-form__submit");
        var buttonText = button ? button.querySelector("[data-add-to-cart-text]") : null;
        var priceWrapper = section.querySelector("[data-price-wrapper]");

        if (!variant) {
          if (button) {
            button.disabled = true;
            if (buttonText) buttonText.textContent = strings.unavailable || "Indisponibil";
          }
          if (idInput) idInput.disabled = true;
          return;
        }

        if (idInput) {
          idInput.value = variant.id;
          idInput.disabled = false;
        }

        if (button) {
          button.disabled = !variant.available;
          if (buttonText) {
            buttonText.textContent = variant.available
              ? strings.addToCart || "Adaugă în coș"
              : strings.soldOut || "Stoc epuizat";
          }
        }

        if (priceWrapper) renderPrice(priceWrapper, variant);

        var stickyPrice = document.querySelector("[data-sticky-price]");
        if (stickyPrice) stickyPrice.textContent = money(variant.price);

        if (variant.featured_media) switchMedia(section, variant.featured_media.id);

        // Keep the address bar shareable without adding a history entry per click.
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set("variant", variant.id);
          window.history.replaceState({}, "", url.toString());
        }

        section.dispatchEvent(
          new CustomEvent("variant:change", { detail: { variant: variant }, bubbles: true })
        );
      }

      picker.addEventListener("change", update);
    });
  }

  function renderPrice(wrapper, variant) {
    var price = wrapper.querySelector(".price");
    if (!price) return;

    var current = price.querySelector(".price__current");
    var compare = price.querySelector(".price__compare");
    var badge = price.querySelector(".price__badge");
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (current) {
      // Preserve the visually-hidden label that precedes the amount.
      var label = current.querySelector(".visually-hidden");
      current.textContent = money(variant.price);
      if (label) current.insertBefore(label, current.firstChild);
    }

    price.classList.toggle("price--on-sale", !!onSale);

    if (compare) {
      compare.hidden = !onSale;
      if (onSale) {
        var compareLabel = compare.querySelector(".visually-hidden");
        compare.textContent = money(variant.compare_at_price);
        if (compareLabel) compare.insertBefore(compareLabel, compare.firstChild);
      }
    }

    if (badge) {
      if (onSale) {
        var percent = Math.round(
          ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price
        );
        badge.hidden = false;
        badge.textContent = "-" + percent + "%";
      } else {
        badge.hidden = true;
      }
    }
  }

  /* ------------------------------------------------------------------------
     Media gallery
     ------------------------------------------------------------------------ */

  function switchMedia(scope, mediaId) {
    var items = scope.querySelectorAll("[data-media-item]");
    var thumbs = scope.querySelectorAll("[data-media-thumb]");
    var target = String(mediaId);
    var found = false;

    Array.prototype.forEach.call(items, function (item) {
      var active = item.getAttribute("data-media-id") === target;
      item.classList.toggle("is-active", active);
      if (active) found = true;
    });

    if (!found) return;

    Array.prototype.forEach.call(thumbs, function (thumb) {
      var active = thumb.getAttribute("data-media-id") === target;
      thumb.classList.toggle("is-active", active);
      thumb.setAttribute("aria-current", active ? "true" : "false");
    });
  }

  // Delegated from document and bound exactly once, so re-initialising a
  // section in the theme editor cannot stack duplicate listeners.
  function initGallery() {
    document.addEventListener("click", function (event) {
      var thumb = event.target.closest("[data-media-thumb]");
      if (!thumb) return;

      event.preventDefault();
      var container = thumb.closest(".product-media") || document;
      switchMedia(container, thumb.getAttribute("data-media-id"));
    });
  }

  /* ------------------------------------------------------------------------
     Sticky buy bar
     ------------------------------------------------------------------------ */

  function initStickyBar() {
    var bar = document.querySelector("[data-sticky-buy]");
    var anchor = document.querySelector(".product-form__submit");
    if (!bar || !anchor || !("IntersectionObserver" in window)) return;

    // Show the bar only once the real add-to-cart button has scrolled away.
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.hidden = !passed;
          bar.classList.toggle("is-visible", passed);
        });
      },
      { threshold: 0 }
    );

    observer.observe(anchor);
  }

  /* ------------------------------------------------------------------------
     COD mode (EasySell)

     COD mode hides the native add-to-cart button, but it deliberately stays in
     the DOM: EasySell looks for it and injects its order form directly below.
     If that injection never happens — app uninstalled, script blocked, an error
     on their side — the shop would be left with no way to order at all. So we
     watch for EasySell's markup and, if nothing shows up in time, give the
     native button back.
     ------------------------------------------------------------------------ */

  var COD = {
    // EasySell's markup is not a stable public API, so match generously and
    // treat "something app-shaped appeared" as success.
    selector:
      '[class*="easysell" i], [id*="easysell" i], [data-easysell], ' +
      'form[action*="easysell" i], [class*="cod-form" i], [id*="cod-form" i]',

    init: function () {
      var cod = config.cod;
      if (!cod || !cod.enabled) return;

      COD.initJump();

      var hidden = document.querySelectorAll(".product-form__submit.is-cod-hidden");
      if (!hidden.length) return;

      if (COD.present()) return;

      var slot = document.querySelector("[data-cod-slot]");
      var settled = false;

      function accept() {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        if (observer) observer.disconnect();
      }

      function restore(reason) {
        if (settled) return;
        settled = true;
        if (observer) observer.disconnect();

        Array.prototype.forEach.call(hidden, function (btn) {
          btn.classList.remove("is-cod-hidden");
        });

        // "Cumpără acum" points at a form that never arrived, so it goes away
        // and the native button takes over.
        Array.prototype.forEach.call(
          document.querySelectorAll("[data-cod-buy]"),
          function (el) { el.hidden = true; }
        );

        if (slot) slot.setAttribute("data-cod-fallback", reason);
        document.documentElement.classList.add("cod-fallback");
      }

      var observer = null;
      if ("MutationObserver" in window) {
        observer = new MutationObserver(function () {
          if (COD.present()) accept();
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }

      var wait = (parseFloat(cod.fallbackSeconds) || 4) * 1000;
      var timer = setTimeout(function () {
        if (COD.present()) accept();
        else restore("timeout");
      }, wait);
    },

    present: function () {
      return !!document.querySelector(COD.selector);
    },

    /** Sticky mobile bar: take the shopper to the COD form, not to a cart. */
    initJump: function () {
      document.addEventListener("click", function (event) {
        var trigger = event.target.closest("[data-cod-jump]");
        if (!trigger) return;

        event.preventDefault();

        var target =
          document.querySelector(COD.selector) ||
          document.querySelector("[data-cod-slot]") ||
          document.querySelector(".product-form__submit");

        if (!target) return;

        target.scrollIntoView({ behavior: "smooth", block: "center" });
        target.classList.add("is-cod-flash");
        setTimeout(function () {
          target.classList.remove("is-cod-flash");
        }, 1200);

        var field = target.querySelector("input, select, textarea");
        if (field) setTimeout(function () { field.focus({ preventScroll: true }); }, 450);
      });
    }
  };

  /* ------------------------------------------------------------------------
     Share
     ------------------------------------------------------------------------ */

  function initShare() {
    document.addEventListener("click", function (event) {
      var button = event.target.closest("[data-share-button]");
      if (!button) return;

      event.preventDefault();
      var url = button.getAttribute("data-share-url") || window.location.href;

      if (navigator.share) {
        navigator.share({ url: url, title: document.title }).catch(function () {
          // The visitor dismissed the sheet; nothing to recover from.
        });
        return;
      }

      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          var original = button.textContent;
          button.textContent = strings.copied || "Link copiat";
          setTimeout(function () {
            button.textContent = original;
          }, 2000);
        });
      }
    });
  }

  /* ------------------------------------------------------------------------
     Boot
     ------------------------------------------------------------------------ */

  function init(scope) {
    initVariantPicker(scope);
    initStickyBar();
  }

  function boot() {
    // Document-level delegation: bind once, never on section reload.
    initGallery();
    initShare();
    COD.init();
    init(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
